var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"sidebar-form",attrs:{"action":"#","method":"get"}},[_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","name":"q","placeholder":"Search..."}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-flat",attrs:{"type":"submit","name":"search","id":"search-btn"}},[_c('i',{staticClass:"fa fa-search"})])])])])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/side-bar/Search.vue